<script>
import { currency } from "@/filters/currency";

export default {
  name: "siprelad-contracts",
  data: () => ({
    result: {},
    currentPage: 1,
    filters: {
      siprelad_state_sync: null,
    },
    sipreladStatus: [
      {
        text: "Todos",
        value: null
      },
      {
        text: "Sincronizado",
        value: "success"
      },
      {
        text: "Error",
        value: "error"
      },
      {
        text: "Error - Máx. intentos",
        value: "error_max_attempts"
      },
    ]
  }),
  computed: {
    totalPages() {
      return Math.ceil(this.result.total / this.result.per_page);
    }
  },
  mounted() {
    this.search();
  },
  methods: {
    currency,
    async syncAll() {
      this.$vs.loading();
      try {
        await axios.post(`/api/backoffice/aml/siprelad/operations/sync`, {
          filters: this.filters
        })
      } catch (e) {
        this.$vs.notify({
          title: "Error",
          text: e.response.data.error,
          color: "danger",
          iconPack: "feather",
          icon: "icon-alert-circle"
        });
      } finally {
        this.$vs.loading.close();
        await this.search();
      }
    },
    async sync(item) {
      this.$vs.loading();
      try {
        await axios.put(`/api/backoffice/aml/siprelad/operations/${item.id}/sync`, {
          type: item.type
        })
        this.$vs.notify({
          title: "Éxito",
          text: "Se envío la solicitud de sincronización",
          color: "success",
          iconPack: "feather",
          icon: "icon-check"
        });
      } catch (e) {
        this.$vs.notify({
          title: "Error",
          text: e.response.data.error,
          color: "danger",
          iconPack: "feather",
          icon: "icon-alert-circle"
        });
      } finally {
        this.$vs.loading.close();
      }
    },
    formatNumber(value) {
      return new Intl.NumberFormat("es-MX").format(value);
    },
    formatStatus(status) {
      switch (status) {
        case "success":
          return "Sincronizado";
        case "error":
          return "Error";
        case "error_max_attempts":
          return "Error - Máx. intentos";
        default:
          return "Pendiente";
      }
    },
    async search() {
      this.$vs.loading();
      try {
        const { data } = await axios.post(`/api/backoffice/aml/siprelad/operations/search?page=${this.currentPage}`, {
          filters: this.filters
        })
        this.result = data;
      } catch (e) {
        this.$vs.notify({
          title: "Error",
          text: e.response.data.error,
          color: "danger",
          iconPack: "feather",
          icon: "icon-alert-circle"
        });
      } finally {
        this.$vs.loading.close();
      }
    }
  }
}
</script>

<template>
  <div class="container">
    <vx-card title="Resumen" class="mb-5">
      <div>
        <div class="grid grid-cols-4 gap-4">
          <div v-for="item in result.resume" class="flex flex-col gap-2 text-center border shadow p-2 rounded-lg">
            <div>{{ formatStatus(item.siprelad_state_sync) }}</div>
            <div class="text-2xl font-bold">{{ formatNumber(item.total) }}</div>
          </div>
        </div>
      </div>
    </vx-card>

    <vx-card title="Perfiles SIPRELAD">
      <template slot="actions">
        <div class="flex items-end gap-4">
          <vs-input label="UID" v-model="result.search" placeholder="Buscar por ID" />
          <vs-select label="Siprelad status" v-model="filters.siprelad_state_sync">
            <vs-select-item v-for="(item, index) in sipreladStatus" :key="index" :value="item.value"
              :text="item.text" />
          </vs-select>
          <vs-button icon="search" color="primary" @click="search" />
          <vs-button color="black" @click="syncAll" icon="sync">
            Sincronizar
          </vs-button>
        </div>
      </template>
      <vs-table :data="result.data">
        <template slot="thead">
          <vs-th>Id</vs-th>
          <vs-th>Cuenta envío</vs-th>
          <vs-th>Cuenta recepción</vs-th>
          <vs-th>Monto</vs-th>
          <vs-th>Tipo operación</vs-th>
          <vs-th>Estado</vs-th>
          <vs-th>No. intentos</vs-th>
          <vs-th>Último intento</vs-th>
          <vs-th>Error</vs-th>
          <vs-th>Opciones</vs-th>
        </template>
        <template slot-scope="{data}">
          <vs-tr v-for="item in data">
            <vs-td>{{ item.id }}</vs-td>
            <vs-td>{{ item.send_account }}</vs-td>
            <vs-td>{{ item.receive_account }}</vs-td>
            <vs-td>{{ currency(item.amount) }}</vs-td>
            <vs-td>{{ item.trx_flow_type }}</vs-td>
            <vs-td>{{ item.siprelad_state_sync || 'NA' }}</vs-td>
            <vs-td>{{ item.siprelad_sync_attempts }}</vs-td>
            <vs-td>{{ item.siprelad_last_sync }}</vs-td>
            <vs-td>{{ item.siprelad_log }}</vs-td>
            <vs-td>
              <vs-button color="black" icon="refresh" @click="sync(item)">
              </vs-button>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
      <template slot="footer">
        <vs-pagination v-model="currentPage" :total="totalPages" @change="search"></vs-pagination>
      </template>
    </vx-card>
  </div>
</template>

<style scoped></style>